import { render, staticRenderFns } from "./StaffDepartment.vue?vue&type=template&id=d5afbf5a&"
import script from "./StaffDepartment.vue?vue&type=script&lang=ts&"
export * from "./StaffDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports